<script setup lang="ts">
import { cn } from "@client/lib/utils";
import { GripVertical } from "lucide-vue-next";
import {
	SplitterResizeHandle,
	type SplitterResizeHandleEmits,
	type SplitterResizeHandleProps,
	useForwardPropsEmits,
} from "reka-ui";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	SplitterResizeHandleProps & { class?: HTMLAttributes["class"]; withHandle?: boolean }
>();
const emits = defineEmits<SplitterResizeHandleEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;
	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<SplitterResizeHandle
		v-bind="forwarded"
		:class="
			cn(
				`tw:relative tw:flex tw:w-px tw:items-center tw:justify-center tw:bg-[rgba(255,255,255,0.2)]
				tw:after:absolute tw:after:inset-y-0 tw:after:left-1/2 tw:after:w-1 tw:after:-translate-x-1/2
				tw:focus-visible:outline-none tw:focus-visible:ring-1 tw:focus-visible:ring-slate-950
				tw:focus-visible:ring-offset-1 tw:[&[data-orientation=vertical]]:h-px
				tw:[&[data-orientation=vertical]]:w-full tw:[&[data-orientation=vertical]]:after:left-0
				tw:[&[data-orientation=vertical]]:after:h-1 tw:[&[data-orientation=vertical]]:after:w-full
				tw:[&[data-orientation=vertical]]:after:-translate-y-1/2
				tw:[&[data-orientation=vertical]]:after:translate-x-0
				tw:[&[data-orientation=vertical]>div]:rotate-90 tw:dark:bg-slate-800
				tw:dark:focus-visible:ring-slate-300`,
				props.class,
			)
		">
		<template v-if="props.withHandle">
			<div
				class="tw:z-10 tw:flex tw:h-4 tw:w-3 tw:items-center tw:justify-center tw:rounded-sm tw:border
					tw:border-slate-200 tw:-translate-y-[21dvh] tw:bg-slate-200 tw:dark:border-slate-800
					tw:dark:bg-slate-800">
				<GripVertical class="tw:h-2.5 tw:w-2" />
			</div>
		</template>
	</SplitterResizeHandle>
</template>
